export default "__VITE_ASSET__RxLQYCs___"